import { initialsValue } from "../../helpers";
import { classNames } from "../../helpers/classNames";
import Indentification from "../elements/Indentification";

const ReviewPreview = ({ review, classes }) => {
  if (!review) return null;

  return (
    <div className={classNames("mb-4 bg-slate-50 rounded-xl transition-all duration-300 p-3", classes)}>
      <div className="flex items-start gap-3">
        {/* Avatar */}
        <div className="w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center shadow-sm">
          {review.userAvatar ? (
            <img
              src={review.userAvatar}
              alt={review.userName}
              className="w-full h-full rounded-full object-cover"
            />
          ) : (
            <Indentification
              initial={initialsValue(review.userName || "A")}
              image={null}
              alt={review.userName || "User"}
              fill={true}
            />
          )}
        </div>

        <div className="flex-1 min-w-0">
          {/* User Info and Rating */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="text-sm font-semibold text-gray-900 truncate">
                {review.userName || "Anonymous"}
              </span>
              {review.isVerified && (
                <div className="flex items-center justify-center w-4 h-4 bg-green-500 rounded-full">
                  <i className="fa-solid fa-check text-white text-xs"></i>
                </div>
              )}
            </div>
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, index) => (
                <i
                  key={index}
                  className={`fa-solid fa-star text-xs ${index < review.rating ? "text-amber-400" : "text-gray-200"
                    }`}
                ></i>
              ))}
            </div>
          </div>
          {/* Review Date */}
          {review.date && (
            <span className="text-xs text-gray-500">
              {new Date(review.date).toLocaleDateString()}
            </span>
          )}

          {/* Review Text */}
          <p className="text-sm text-gray-700 line-clamp-2 leading-relaxed mb-2">
            {review.comment}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReviewPreview;
